module.exports = __webpack_public_path__ + "static/img/solution-2.f68857c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-2.png
// module id = vCtB
// module chunks = 10